import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getParlamentDecisionById } from '../../api/councilService';
import { format } from 'date-fns';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

export default function CouncilDetail() {
  const { urlTag } = useParams();
  const location = useLocation();
  const guid = location.state?.guid;
  const [decision, setDecision] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('Current location state:', location.state);
    console.log('Current guid value:', guid);
    console.log('Current urlTag value:', urlTag);

    const fetchDecisionDetail = async () => {
      try {
        setLoading(true);
        console.log('Sending guid:', guid);
        const response = await getParlamentDecisionById(guid);
        console.log('API Response:', response);
        if (response.isSuccess) {
          setDecision(response.data);
        } else {
          console.log('Error response:', response);
          setError('Karar detayı yüklenirken bir hata oluştu');
        }
      } catch (err) {
        console.log('Caught error:', err);
        setError('Karar detayı yüklenirken bir hata oluştu');
        console.error('Error details:', err.response?.data || err);
      } finally {
        setLoading(false);
      }
    };

    fetchDecisionDetail();
  }, [guid]);

  const handleDownload = () => {
    if (decision?.fileUrl) {
      window.open(decision.fileUrl, '_blank');
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  if (error || !decision) {
    return (
      <div className="alert alert-danger m-5">
        {error || 'Karar bulunamadı'}
      </div>
    );
  }

  return (
    <div>
      <div className="container py-4">
        <div className="row">

            <QuickMenu />
        
          <div className="col-md-10">
            <div className="council-detail">
              <div className="council-detail-title">
                <h2>{decision.header}</h2>
              </div>
              <div className="council-detail-meta">
                <p><span>Tarih:</span>{format(new Date(decision.date), 'dd MMMM yyyy')} </p>
                <p><span>Karar No:</span>{decision.decisionsNo || '-'} </p>
              </div>
              <div className="council-detail-content">
                <div 
                  className="council-detail-text-content"
                  dangerouslySetInnerHTML={{ __html: decision.detail || '' }}
                />
              </div>

              <div className="council-detail-boxes">
                <div className="council-detail-box">
                  <div className="council-detail-box-left">
                    <h4>{decision.header}</h4>
                    <span>{format(new Date(decision.date), 'dd MMMM yyyy')} </span>
                  </div>
                  <div className="council-detail-box-right">
                    {decision.fileUrl && (
                      <button onClick={handleDownload}>İndir</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
